import { organizationAPI, branchAPI } from '../services/api';

/**
 * Get organization details for printing based on user role
 * - For Admin: Get organization from user's organizationId
 * - For Super Admin: Get organization from selected branch's organizationId
 * 
 * @returns {Promise<Object|null>} Organization object or null if not found
 */
export const getOrganizationForPrint = async () => {
  try {
    // Get user from localStorage (since this is a utility function, not a component)
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    const user = JSON.parse(userStr);
    const isSuperAdmin = user?.isSuperAdmin === true;
    
    if (isSuperAdmin) {
      // For Super Admin: Get selected branch from localStorage
      const selectedBranchId = localStorage.getItem('selectedBranchId');
      if (!selectedBranchId) return null;
      
      // Get branch details
      const branchResponse = await branchAPI.getById(parseInt(selectedBranchId, 10));
      const branch = branchResponse.data;
      
      if (!branch || !branch.organizationId) return null;
      
      // Get organization from branch
      const orgResponse = await organizationAPI.getById(branch.organizationId || branch.OrganizationId);
      return orgResponse.data;
    } else {
      // For Admin: Get organization from user's organizationId
      const userOrgId = user?.organizationId || user?.OrganizationId;
      if (!userOrgId) return null;
      
      const orgResponse = await organizationAPI.getById(userOrgId);
      return orgResponse.data;
    }
  } catch (error) {
    console.error('Error getting organization for print:', error);
    return null;
  }
};

